import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgArrowDownIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
    <path fill="none" d="M0 0h24v24H0V0z" />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgArrowDownStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgArrowDownIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const ArrowDownIcon: any = SvgArrowDownStyle;
export default ArrowDownIcon;
